import { useEffect } from "react";
import { _ROUTES } from "../../../utils/_routes_constants";
import { DataTable } from "../../ui/DataTable";
import { buildIRI } from "../../../utils/function";
import { useBudgetData } from "../../../hooks/useBudgetData";

export const TableWasteRate = ({
  rows,
  setRows,
  params,
  isDataLoading,
  onDataLoadingStart,
  onDataLoadingStop,
  onRefreshData,
}) => {
  const { loadData, handleCellValueChanged } = useBudgetData({
    setRows,
    onDataLoadingStart,
    onDataLoadingStop,
    params,
    formDataToRow: (data) => data,
  });

  useEffect(() => {
    loadData(_ROUTES.IPT_WASTE_RATE_GROUP);
  }, [params.activity]);

  const generateWasteRatePayload = ({ data, newValue }) => {
    const payload = {
      site: buildIRI("/sites", data.siteId),
      fiscalYear: params.fiscalYear,
      version: params.version || 1,
    };

    if (data.wasteSource) {
      payload.wasteSource = data.wasteSource;
    }

    if (data.wasteIndustrial) {
      payload.wasteIndustrial = data.wasteIndustrial;
    }

    if (data.wasteRateId !== null) {
      payload.id = data.wasteRateId;
    }

    return payload;
  };

  const handleCellChange = async (agParams) => {
    const ret = await handleCellValueChanged(
      agParams,
      generateWasteRatePayload,
      _ROUTES.IPT_WASTE_RATE,
    );
    if (ret === undefined) {
      loadData(_ROUTES.IPT_WASTE_RATE_GROUP);
    }
    if (onRefreshData) onRefreshData();
  };

  return (
    <DataTable
      isDataLoading={isDataLoading}
      rows={rows}
      columnsIncludeMonths={false}
      columns={[
        {
          headerName: "Site",
          field: "siteName",
          width: 300,
        },
        {
          headerName: "Waste industrial",
          field: "wasteIndustrial",
          editable: true,
          cellDataType: "number",
          cellStyle: () => {
            return { textAlign: "center" };
          },
          valueFormatter: (params) => {
            // Affichage avec %
            return params.value != null ? `${params.value}%` : "";
          },
          valueParser: (params) => {
            // Suppression du % lors de l'édition
            const value = params.newValue?.toString().replace("%", "").trim();
            return parseFloat(value) || 0;
          },
        },
        {
          headerName: "Waste source",
          field: "wasteSource",
          editable: true,
          cellDataType: "number",
          cellStyle: () => {
            return { textAlign: "center" };
          },
          valueFormatter: (params) => {
            // Affichage avec %
            return params.value != null ? `${params.value}%` : "";
          },
          valueParser: (params) => {
            // Suppression du % lors de l'édition
            const value = params.newValue?.toString().replace("%", "").trim();
            return parseFloat(value) || 0;
          },
        },
      ]}
      onCellValueChanged={handleCellChange}
    />
  );
};
